import { isOpen } from '#utilities/js/lightboxes/seamless.js'
import { close, preventClose } from '#utilities/js/lightboxes/lightbox.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import stopImmediatePropagation from '@mailobj-browser/front/js/events/hooks/stopImmediatePropagation.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import capture from '@mailobj-browser/front/js/events/options/capture.js'
import once from '@mailobj-browser/front/js/events/options/once.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import keyUp from '@mailobj-browser/front/js/events/types/keyUp.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const onEscape = object(listener, {
  type: keyUp,
  task: (document, event) => {
    const { key } = event
    const anchor = one('[data-contract~="modal.close"] ', document)

    if (!anchor || key !== 'Escape') {
      return
    }

    const { children } = closest('aside', anchor)
    const { length } = children

    if (length === 1) {
      preventDefault(event)
      stopImmediatePropagation(event)
      
      if (key === 'Escape' && isOpen()) {
	    preventClose()
console.log('escaped')
        return
      }

      anchor.click()
    }
  }
})

const onClick = object(listener, {
  type: click,
  capture,
  passive,
  task: close
})

export default element => {
  const { ownerDocument } = element

  onClick.listen(element)
  onEscape.listen(ownerDocument)
}
